import { useState } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { pros } from '@/mocks/homeData';
import VideoThumbnail from '@/components/base/VideoThumbnail';

export default function ProSection() {
  const ref = useScrollAnimation<HTMLDivElement>();
  const ref2 = useScrollAnimation<HTMLDivElement>();
  const [hovered, setHovered] = useState(false);

  return (
    <>
      <section id="pro" className="bg-white">
        <div className="bg-primary py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-2xl md:text-4xl font-bold text-white text-center">소속프로소개</h1>
          </div>
        </div>
        <div ref={ref} className="scroll-animate py-16 md:py-24 px-4 md:px-6">
          <div className="max-w-6xl mx-auto space-y-16 md:space-y-24">
            {pros.map((pro, i) => (
              <div
                key={i}
                className={`flex flex-col ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-8 md:gap-12`}
              >
                <div className="w-full md:w-1/2">
                  <div
                    className="relative aspect-[3/4] max-w-md mx-auto overflow-hidden rounded-lg bg-gray-100 cursor-pointer"
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                  >
                    <img src={pro.image} alt={pro.name} className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-500 ${hovered ? 'opacity-0' : 'opacity-100'}`} loading="lazy" />
                    <img src="/media/img21.jpg" alt={pro.name} className={`absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-500 ${hovered ? 'opacity-100' : 'opacity-0'}`} loading="lazy" />
                  </div>
                </div>
                <div className="w-full md:w-1/2">
                  <h6 className="text-sm font-semibold text-accent uppercase tracking-wider mb-2">{pro.role}</h6>
                  <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4">{pro.name}</h2>
                  <div className="w-12 h-0.5 bg-gray-300 mb-6" />
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-arrow-right-s-fill text-primary" />
                      </div>
                      <span className="text-sm md:text-base text-gray-700">LPGA Class A🇺🇸</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-arrow-right-s-fill text-primary" />
                      </div>
                      <span className="text-sm md:text-base text-gray-700">TPI Certified🇺🇸</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-arrow-right-s-fill text-primary" />
                      </div>
                      <span className="text-sm md:text-base text-gray-700">Team Srixon</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-arrow-right-s-fill text-primary" />
                      </div>
                      <span className="text-sm md:text-base text-gray-700">GF GOLF 운영</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-arrow-right-s-fill text-primary" />
                      </div>
                      <span className="text-sm md:text-base text-gray-700">Golf Digest 잡지 스윙모델</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-arrow-right-s-fill text-primary" />
                      </div>
                      <span className="text-sm md:text-base text-gray-700">Cj그룹 주니어 후원 선수 출신</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-arrow-right-s-fill text-primary" />
                      </div>
                      <span className="text-sm md:text-base text-gray-700">포르쉐 vvip 대상 공개 세미나 진행</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <div className="w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0">
                        <i className="ri-arrow-right-s-fill text-primary" />
                      </div>
                      <span className="text-sm md:text-base text-gray-700">BMW 챔피언십, 한화 라이프플러스 등 기업 VIP 대상 골프 레슨 진행</span>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section id="pro2" className="bg-white">
        <div className="bg-primary py-12 md:py-16 px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-2xl md:text-4xl font-bold text-white text-center">윤혜민PRO 레슨영상 및 개인영상</h1>
          </div>
        </div>
        <div ref={ref2} className="scroll-animate py-16 md:py-24 px-4 md:px-6">
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="flex flex-col gap-4">
              <div className="w-full aspect-[9/16] rounded-lg overflow-hidden bg-black">
                <VideoThumbnail
                  src="/media/video01.mp4"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-1">1:1 레슨 현장</h3>
                <p className="text-sm text-gray-600">회원님과 함께하는 열정적인 실전 레슨 현장입니다. 체력 단련과 스윙 교정을 동시에 진행하는 훈련 모습을 담았습니다.</p>
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <div className="w-full aspect-[9/16] rounded-lg overflow-hidden bg-black">
                <VideoThumbnail
                  src="/media/video02.mp4"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-1">숏게임 실전 레슨</h3>
                <p className="text-sm text-gray-600">매주 수요일·일요일 진행되는 숏게임 실전 레슨. 그린 주변에서 어려움을 겪는 회원님들을 위한 특화 프로그램입니다.</p>
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <div className="w-full aspect-[9/16] rounded-lg overflow-hidden bg-black">
                <VideoThumbnail
                  src="/media/video03.mp4"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900 mb-1">Approach ASMR</h3>
                <p className="text-sm text-gray-600">클리브랜드 클럽과 스릭슨 볼을 활용한 정교한 어프로치 연습 장면입니다. LPGA 공식 의류로 완성한 프로페셔널한 훈련 모습입니다.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}